export default __webpack_public_path__ + "images/logo-full.84e791cc16478ef21f1d4fded5e3305a.png";